import { httpPost, httpDownload, httpGet, httpPostFile } from '../../../utils/api.utils';
import { DEFAULT_TABLE_RESULT_MODEL, REPORT_COLUMN_MODULE, INVENTORY_REPORT_HEADERS as inventoryReportHeaders, 
        INVENTORY_REPORT_PROPS as inventoryReportProps} from '../../../constants/external-constants';
import Moment from 'moment';
import { getLocalTimeZone, convertToFormatLocalDate } from '../../../utils/helpers.utils';
import { actions } from 'react-redux-form';

import {
    circuitDetailsModel,
    locationModel,
    getInventoryCircuit,
    getEquipmentDetailsList,
    setInventoryCircuitError,
    setInventoryCircuitColSearchStr,
    sortInventoryCircuitItems,
    setInventoryCircuitPageSize,
    setInventoryCircuitFilter,
    applyInventoryCircuitFilter,
    getInventoryCircuitDetail,
    getInventoryUserDetail,
    getInventoryUserCircuitAllocation,
    getUserLinkedCircuit,
    getInventoryAccountDetail,
    getInventoryAccountCostAllocationModal,
    getAccountLinkedCircuit,
    getInventoryCircuitComments,
    getInventoryCircuitTypesByCategory,
    getInventoryAllSubCircuitTypes,
    resetInventoryCircuitData,
    setInventoryCircuitFormSubmitted,
    updateChangeLocationSite,
    updateChangeLocationSiteP2P,
    getInventoryCircuitCostCenterList,
    setUserLinkedCircuitSearchValue,
    setAccountLinkedCircuitSearchValue,
    GetlinkCircuitsByBillingAccountIdAndCircuitTypeId,
    getInventoryAllDropdownList
} from '../../../constants/model-reducers/external/inventory/circuit-details/circuit.settings';
import { batch } from 'react-redux';

export const circuitDetailsFormInitialState = circuitDetailsModel;
export const location1FormInitialState = locationModel;
export const location2FormInitialState = locationModel;

const defaultState = () => ({
    isInventoryCircuitLoaded: false,
    isInventoryCircuitError: false,
    isInventoryUserDetailLoaded: false,
    isInventoryUserDetailError: false,
    isInventoryAccountDetailLoaded: false,
    isInventoryAccountDetailError: false,
    inventoryCircuitItems: DEFAULT_TABLE_RESULT_MODEL,
    inventoryEquipmentItems: DEFAULT_TABLE_RESULT_MODEL,
    inventoryLinkedCircuit: DEFAULT_TABLE_RESULT_MODEL,
    inventoryAccountLinkedCircuitTable: DEFAULT_TABLE_RESULT_MODEL,
    inventoryCircuitColSort: '',
    inventoryCircuitIsSortedAsc: true,
    inventoryCircuitTableFilterList: [],
    inventoryCircuitTableFilterApply: false,
    inventoryCircuitDetail: {
        linkedCircuitOptions: [],
    },
    inventoryUserCircuitAllocation: [],
    inventoryAccountCostAllocationModal: [],
    inventoryUserLinkedCircuit: DEFAULT_TABLE_RESULT_MODEL,
    inventoryAccountLinkedCircuit: DEFAULT_TABLE_RESULT_MODEL,
    inventoryUserHrDetails:{
        hrSapId: "",
        firstName: "",
        lastName: "",
        middle: "",
        emailAdd: "",
        position: "",
        status: "",
        dateleft: "",
        firstLineManagerId: "",
        firstLineManagerEmailAdd: "",
        secondLineManagerId: "",
        secondLineManageremailAdd: "",
        delegateAprover: "",
        locationSiteId: "",
        address1: "",
        address2: "",
        city: "",
        locationState: "",
        country: "",
        locationZip: "",
    },
    inventoryAccountDetails:{
        accountNumber: "",
        accountType: "",
        contractID: "",
        vendor: "",
        currency: "",
        serviceType: "",
        status: "",
        client: "",
        allocationLevel: "",
        apVendorID: "",
        remitID: "",
        billingAddress: "",
        remitAddress: "",
    },
    inventoryAllAccountDetails: [],
    inventoryAllAccountStatuses: [],
    inventoryAllCircuitRankings: [],
    inventoryAllAccountTypes: [],
    inventoryAllCircuitTypes: [],
    inventorySubCircuitTypes: [],
    inventoryAllCircuitEquipment: [],
    inventoryAllCircuitEquipmentModel: [],
    inventoryEquipmentDetailsList: [],
    inventoryAllLocations: [],
    inventoryAllCircuitSimTypes: [],
    inventoryAllEmployees: [],
    inventoryCircuitServiceClass: [],
    inventoryCircuitComments: [],
    circuitCostCenterList: [],
    circuitGlCodeList: [],
    linkedCircuitsOptions: [],
    originalLinkedCircuitId: null
});

const initialState = defaultState();

const createHeader = (order, propName, name, hidden = false) => ({
    propName,
    hidden,
    order,
    name
});


export const inventoryCircuitActions = {
    saveCircuitDetails: (circuitID, confirmSavePropName, validate, planUpdated) => async (dispatch, state) => {
        const { circuitDetails, location1, location2, accessInformation, pipInformation } = state().form.inventoryCircuitForm;
        const { planDetails } = state().inventoryCircuitPlanDetails;
        const { circuitSimList } = state().inventoryCircuitSIM;
        const { circuitEquipList } = state().inventoryCircuitEquip;
        const { circuitCostAllocation } = state().inventoryCostAllocation;
        
        var circuitCodeConfirmation = circuitDetails.circuitCodeConfirmation;
        var primarySecondaryConfirmation = circuitDetails.primarySecondaryConfirmation;

        if (confirmSavePropName === "circuitCode") {
            circuitCodeConfirmation = true;
            dispatch(actions.change("inventoryCircuitForm.circuitDetails.circuitCodeConfirmation", circuitCodeConfirmation));
        }
        else if (confirmSavePropName === "primarySecondary") {
            primarySecondaryConfirmation = true;
            dispatch(actions.change("inventoryCircuitForm.circuitDetails.primarySecondaryConfirmation", primarySecondaryConfirmation));
        }

        const detailsForm = {
            ...circuitDetails,
            circuitCodeConfirmation: circuitCodeConfirmation,
            primarySecondaryConfirmation: primarySecondaryConfirmation,
            statusID: parseInt(circuitDetails.statusID),
            circuitTypeID: parseInt(circuitDetails.circuitTypeID),
            subCircuitTypeID: circuitDetails.subCircuitTypeID ? parseInt(circuitDetails.subCircuitTypeID) : null,
            monthlyRateCharge: circuitDetails.monthlyRateCharge ? parseFloat(circuitDetails.monthlyRateCharge) : 0.00,
            linkedCircuitID: circuitDetails.linkedCircuitID ? parseInt(circuitDetails.linkedCircuitID) : null,
            billingAccountID: parseInt(circuitDetails.billingAccountID),
            endUserID: circuitDetails.endUserID ? parseInt(circuitDetails.endUserID) : null,
            installDate: circuitDetails.installDate ? Moment(circuitDetails.installDate).startOf('day').format('DD MMM YYYY') : null,
            disconnectDate: circuitDetails.disconnectDate ? Moment(circuitDetails.disconnectDate).startOf('day').format('DD MMM YYYY') : null,
            suspensionFromDate: circuitDetails.suspensionFromDate ? Moment(circuitDetails.suspensionFromDate).startOf('day').format('DD MMM YYYY') : null,
            suspensionToDate: circuitDetails.suspensionToDate ? Moment(circuitDetails.suspensionToDate).startOf('day').format('DD MMM YYYY') : null,
            contractEndDate: circuitDetails.contractEndDate ? Moment(circuitDetails.contractEndDate).startOf('day').format('DD MMM YYYY') : null,
            location1ID: location1.locationID ? parseInt(location1.locationID) : null,
            demarc1Location: location1.demarcLocation ? location1.demarcLocation : null,
            location2ID: location2.locationID ? parseInt(location2.locationID) : null,
            demarc2Location: location2.demarcLocation ? location2.demarcLocation : null
        };

        const accessInformationForm = {
            ...accessInformation,
            siteSurveyRequested: accessInformation.siteSurveyRequested ? parseInt(accessInformation.siteSurveyRequested) : null,
            accessBandwidth: accessInformation.accessBandwidth ? parseInt(accessInformation.accessBandwidth) : null,
            access: accessInformation.access ? parseInt(accessInformation.access) : null,
            isThisCoordinatedService: accessInformation.isThisCoordinatedService ? parseInt(accessInformation.isThisCoordinatedService) : null,
            electricalOpticalInterface: accessInformation.electricalOpticalInterface ? parseInt(accessInformation.electricalOpticalInterface) : null,
            requiredLOACFA: accessInformation.requiredLOACFA ? parseInt(accessInformation.requiredLOACFA) : null,
            serviceClass: accessInformation.serviceClass ? parseInt(accessInformation.serviceClass) : null,
        };

        const pipInformationForm = {
            ...pipInformation,
            portSpeed: pipInformation.portSpeed ? parseInt(pipInformation.portSpeed) : null,
            carrierQOSProfile: pipInformation.carrierQOSProfile ? parseInt(pipInformation.carrierQOSProfile) : null,
            voiceCAR: pipInformation.voiceCAR ? parseInt(pipInformation.voiceCAR) : null,
            vpnName: pipInformation.vpnName ? parseInt(pipInformation.vpnName) : null,
            voiceCARSpeed: pipInformation.voiceCARSpeed ? parseInt(pipInformation.voiceCARSpeed) : null,
            asnNewOrExisting: pipInformation.asnNewOrExisting ? parseInt(pipInformation.asnNewOrExisting) : null,
            siteOfOrigin: pipInformation.siteOfOrigin ? parseInt(pipInformation.siteOfOrigin) : null
        };

        var planDetailsData = planDetails.datatable;
        var planId = planDetailsData.length > 0 ? (planDetailsData[0].dataItem.length > 0 ? planDetailsData[0].dataItem[0].PlanId : null) : null;
        var simData = circuitSimList.datatable.length > 0 ? circuitSimList.datatable[0].dataItem : [];
        var equipmentData = circuitEquipList.datatable.length > 0 ? circuitEquipList.datatable[0].dataItem : [];
        var circuitCostAllocations = circuitCostAllocation.datatable.length > 0 ? circuitCostAllocation.datatable[0].dataItem : [];

        var formData = {
            ...detailsForm,
            accessInformation: {
                ...accessInformationForm
            },
            pipInformation: {
                ...pipInformationForm
            },
            planID: planId ? parseInt(planId) : null,
            circuitSIMs: simData,
            circuitEquipments: equipmentData,
            circuitCostAllocations: circuitCostAllocations,
            hasSelectedNewPlan: planUpdated
        };

        var result = await httpPost(`external/inventory/save/${circuitID}/${validate}`, formData);

        dispatch(actions.resetErrors('inventoryCircuitForm'));
        
        if (result.success === false) {
            if (result.propertyName === "circuitCode") {
                dispatch(actions.setErrors("inventoryCircuitForm.circuitDetails.circuitCode", true));
            }
            else if (result.propertyName === "primarySecondary") {
                dispatch(actions.setErrors("inventoryCircuitForm.circuitDetails.primarySecondary", true));
            }
            else if (result.propertyName === "circuitSIMs") {
                dispatch(actions.setErrors("inventoryCircuitForm.circuitSIMs", true));
            }
            else if (result.propertyName === "circuitCostAllocations") {
                dispatch(actions.setErrors("inventoryCircuitForm.circuitCostAllocations", true));
            }
        }
        else {
            const { inventoryCircuit } = state();
            try {
                var circuitTable = await getInventoryCircuitTable(inventoryCircuit);

                dispatch({
                    type: getInventoryCircuit,
                    inventoryItems: Object.keys(circuitTable).length > 0 ? circuitTable : DEFAULT_TABLE_RESULT_MODEL,
                    isInventoryCircuitLoaded: true,
                    isInventoryCircuitError: false
                });
            }
            catch (e) {
                dispatch({
                    type: setInventoryCircuitError,
                    isInventoryCircuitError: true,
                    isInventoryCircuitLoaded: false
                });
            }
        }

        return result;
    },
    selectDate: (model, date) => (dispatch) => {
        dispatch(actions.change(model, date));
    },
    selectLocation: (model, locationID) => (dispatch, state) => {
        const { inventoryAllLocations } = state().inventoryCircuit;

        var newCircuitLocation = inventoryAllLocations.find(r => parseInt(r.LocationId) === parseInt(locationID));

        dispatch(actions.change(model, parseInt(locationID)));

        var modelName = model.includes("location1") ? "location1" : (model.includes("location2") ? "location2" : "");

        if (modelName !== "" && newCircuitLocation) {
            dispatch(actions.change(`inventoryCircuitForm.${modelName}.address1`, newCircuitLocation.LocationAddress1));
            dispatch(actions.change(`inventoryCircuitForm.${modelName}.address2`, newCircuitLocation.LocationAddress2));
            dispatch(actions.change(`inventoryCircuitForm.${modelName}.locationType`, newCircuitLocation.LocationType));
            dispatch(actions.change(`inventoryCircuitForm.${modelName}.locationCity`, newCircuitLocation.LocationCity));
            dispatch(actions.change(`inventoryCircuitForm.${modelName}.locationState`, newCircuitLocation.LocationState));
            dispatch(actions.change(`inventoryCircuitForm.${modelName}.locationCountry`, newCircuitLocation.CountryName));
            dispatch(actions.change(`inventoryCircuitForm.${modelName}.locationZip`, newCircuitLocation.LocationZip));
        }
        else{
            dispatch(actions.reset(`inventoryCircuitForm.${modelName}.address1`));
            dispatch(actions.reset(`inventoryCircuitForm.${modelName}.address2`));
            dispatch(actions.reset(`inventoryCircuitForm.${modelName}.locationType`));
            dispatch(actions.reset(`inventoryCircuitForm.${modelName}.locationCity`));
            dispatch(actions.reset(`inventoryCircuitForm.${modelName}.locationState`));
            dispatch(actions.reset(`inventoryCircuitForm.${modelName}.locationCountry`));
            dispatch(actions.reset(`inventoryCircuitForm.${modelName}.locationZip`));
        }

    },
    updateCircuitMRC: (mrc) => (dispatch, state) => {
        dispatch(actions.change('inventoryCircuitForm.circuitDetails.monthlyRateCharge', mrc));
    },
    getInventoryCircuit: (pageIndex = 0, pageUnmount = false) => async (dispatch, state) => {
        const { inventoryCircuit } = state();

        try {
            var result = await getInventoryCircuitTable(inventoryCircuit, pageIndex, pageUnmount);

            dispatch({
                type: getInventoryCircuit,
                inventoryItems: Object.keys(result).length > 0 ? result : DEFAULT_TABLE_RESULT_MODEL,
                isInventoryCircuitLoaded: true,
                isInventoryCircuitError: false
            });
        }
        catch (e) {
            dispatch({
                type: setInventoryCircuitError,
                isInventoryCircuitError: true,
                isInventoryCircuitLoaded: false
            });
        }
    },
    setResetSearch: (key) => async (dispatch, state) =>{
        const { inventoryCircuitItems } = state().inventoryCircuit;
        var inventoryCircuitItemsUpd = {
            ...inventoryCircuitItems,
            "Headers": {}
        }

        dispatch({
            type: setInventoryCircuitColSearchStr,
            data: inventoryCircuitItemsUpd,
            isInventoryCircuitError: false,
            isInventoryCircuitLoaded: false
        });
    }
    ,setInventoryCircuitColSearchStr: (event, key) => async (dispatch, state) => {
        var val = event.target.value;
        const { inventoryCircuitItems } = state().inventoryCircuit;
        var inventoryCircuitItemsUpd = {
            ...inventoryCircuitItems,
            "Headers": {
                ...inventoryCircuitItems.Headers,
                [key]: {

                    ...inventoryCircuitItems.Headers[key],
                    searchString: val
                }
            }
        }

        dispatch({
            type: setInventoryCircuitColSearchStr,
            data: inventoryCircuitItemsUpd,
            isInventoryCircuitError: false,
            isInventoryCircuitLoaded: true
        });
    },
    sortInventoryCircuitItems: (columnClicked, isSortedAsc) => async (dispatch, state) => {
        const { PageNumber, PageSizes } = state().inventoryCircuit.inventoryCircuitItems.Pagination;
        const { inventoryCircuitItems, inventoryCircuitTableFilterList, inventoryCircuitTableFilterApply } = state().inventoryCircuit;
        var data = {
            PageFilter: {
                PageIndex: PageNumber !== undefined ? PageNumber : 0,
                PageSize: inventoryCircuitItems.Pagination.PerPage,
                PageSizes: PageSizes
            },
            Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
            UserId: sessionStorage.getItem('UserID'),
            EmployeeId: sessionStorage.getItem('EmployeeID'),
            Headers: {
                ...inventoryCircuitItems.Headers
            },
            SortedColumnName: columnClicked,
            IsSortAscending: isSortedAsc,
            TableFilterList: inventoryCircuitTableFilterList,
            ApplyFilter: inventoryCircuitTableFilterApply
        };
        var resInventoryCircuitItems = await httpPost('external/inventory/getAllInventoryItems', data);
        if (resInventoryCircuitItems.ok === false) {
            dispatch({
                type: setInventoryCircuitError,
                isInventoryCircuitError: true,
                isInventoryCircuitLoaded: false
            });
        } else {
            dispatch({
                type: sortInventoryCircuitItems,
                inventoryCircuitItems: Object.keys(resInventoryCircuitItems).length > 0 ? resInventoryCircuitItems : DEFAULT_TABLE_RESULT_MODEL,
                inventoryCircuitColSort: columnClicked,
                inventoryCircuitIsSortedAsc: isSortedAsc,
                isInventoryCircuitLoaded: true
            });
        }
    },

    resizeInventoryCircuitPage: (pageSize) => async (dispatch, state) => {
        dispatch({
            type: setInventoryCircuitPageSize,
            pageSize: parseInt(pageSize),
        });
    },

    getInventoryCircuitCostCenterList: () => async (dispatch, state) => {
        var circuitCostCenterList = await httpGet('external/autosuggest/getInventoryCircuitCostCodes');
        if (circuitCostCenterList != null) {
            dispatch({
                type: getInventoryCircuitCostCenterList,
                circuitCostCenterList: circuitCostCenterList,
                isInventoryCircuitLoaded: true,
                isInventoryCircuitError: false
            });
        } else {
            dispatch({
                type: setInventoryCircuitError,
                isInventoryCircuitError: true,
                isInventoryCircuitLoaded: false
            });
        }
    },
        
    extractInventoryCircuits: (id) => async (dispatch, state) => {
        const { Headers } = state().inventoryCircuit.inventoryCircuitItems;
        const { inventoryCircuitIsSortedAsc, inventoryCircuitColSort, inventoryCircuitTableFilterList, inventoryCircuitTableFilterApply } = state().inventoryCircuit;

        const dealName = sessionStorage.getItem('DealName');
        const url = `external/inventory/getAllExtractInventoryItems/${id}`;
        const { activeDateFormat } = state().adminSetting;
        const formattedDate = convertToFormatLocalDate(new Date(), activeDateFormat.Name).replaceAll('/', '-');
        let filename, ExtractHeaders = { Headers: {} };

        // Common filename structure
        const commonFilename = `ATEM ${dealName}`;

        if (id === 0) {
            filename = `${commonFilename} Inventory Extract – ${formattedDate}`;
            ExtractHeaders.Headers = { ...Headers };
        }
        if (id === 1) {
            filename = `${commonFilename} Inventory Report – ${formattedDate}`;
            ExtractHeaders.Headers = {
                Region: createHeader(1, inventoryReportProps.region, inventoryReportHeaders.region),
                CircuitId: createHeader(2, inventoryReportProps.subscriptionNumber, inventoryReportHeaders.circuitNumber),
                Vendor: createHeader(3, inventoryReportProps.vendor, inventoryReportHeaders.vendorName),
                CircuitCountry: createHeader(4, inventoryReportProps.circuitCountry, inventoryReportHeaders.circuitCountry),
                Account: createHeader(5, inventoryReportProps.accountNumber, inventoryReportHeaders.account),
                CircuitRanking: createHeader(6, inventoryReportProps.circuitRanking, inventoryReportHeaders.circuitRanking),
                CircuitStatus: createHeader(7, inventoryReportProps.circuitStatus, inventoryReportHeaders.circuitStatus),
                CircuitType: createHeader(8, inventoryReportProps.circuitType, inventoryReportHeaders.circuitType),
                SubCircuitType: createHeader(9, inventoryReportProps.subCircuitType, inventoryReportHeaders.subCircuitStatus),
                PUKCode: createHeader(10, inventoryReportProps.puk, inventoryReportHeaders.pukCode),
                InServiceDate: createHeader(11, inventoryReportProps.installDateStr, inventoryReportHeaders.inServiceDate),
                CancelledDate: createHeader(12, inventoryReportProps.disconnectDateStr, inventoryReportHeaders.cancelledDate),
                DateLeft: createHeader(13, inventoryReportProps.dateLeftStr, inventoryReportHeaders.dateLeft),
                LastName: createHeader(14, inventoryReportProps.lastName, inventoryReportHeaders.lastName),
                FirstName: createHeader(15, inventoryReportProps.firstName, inventoryReportHeaders.firstName),
                UserName: createHeader(16, inventoryReportProps.userFullName, inventoryReportHeaders.userName),
                UserHRID: createHeader(17, inventoryReportProps.userHRID, inventoryReportHeaders.userHRID),
                UserEmailAddress: createHeader(18, inventoryReportProps.userEmailAdd, inventoryReportHeaders.userEmailAdd),
                UserVIP: createHeader(19, inventoryReportProps.userVIP, inventoryReportHeaders.userVIP),
                CostCode: createHeader(20, inventoryReportProps.costCode, inventoryReportHeaders.costCode),
                Location: createHeader(21, inventoryReportProps.location, inventoryReportHeaders.location),
                UserSiteLocation: createHeader(22, inventoryReportProps.userLocationSite, inventoryReportHeaders.userSiteLocation),
                UserCountry: createHeader(23, inventoryReportProps.userLocationCountry, inventoryReportHeaders.userCountry),
                UserCity: createHeader(24, inventoryReportProps.userLocationCity, inventoryReportHeaders.userCity),
                PrefixCountry: createHeader(25, inventoryReportProps.prefixCountry, inventoryReportHeaders.prefixCountry),
                UserJobTitle: createHeader(26, inventoryReportProps.userJobTitle, inventoryReportHeaders.userJobTitle),
                HRTeamName: createHeader(27, inventoryReportProps.hrTeamName, inventoryReportHeaders.hrTeamName),
                IMEISerialNumber: createHeader(28, inventoryReportProps.imei, inventoryReportHeaders.imei),
                DeviceType: createHeader(29, inventoryReportProps.equipmentModel, inventoryReportHeaders.deviceType),
                PlanName: createHeader(30, inventoryReportProps.planName, inventoryReportHeaders.planName),
                PlanComponent: createHeader(31, inventoryReportProps.planComponent, inventoryReportHeaders.planComponent),
                Description: createHeader(32, inventoryReportProps.description, inventoryReportHeaders.description),
                BaseCost: createHeader(33, inventoryReportProps.baseCost, inventoryReportHeaders.baseCost),
                PlanComponentCost: createHeader(34, inventoryReportProps.planComponentCost, inventoryReportHeaders.planComponentCost),
                TotalCost: createHeader(35, inventoryReportProps.totalCost, inventoryReportHeaders.totalCost),
                UserLineManager: createHeader(36, inventoryReportProps.userLineManager, inventoryReportHeaders.userLineManager),
                LineManagersEmail: createHeader(37, inventoryReportProps.lineManagerEmail, inventoryReportHeaders.lineManagersEmail),
                LMVIP: createHeader(38, inventoryReportProps.lmVIP, inventoryReportHeaders.lmVIP),
                LineManagerHRID: createHeader(39, inventoryReportProps.lineManagerHRID, inventoryReportHeaders.lineManagerHRID),
                OrderNumber: createHeader(40, inventoryReportProps.orderNumber, inventoryReportHeaders.orderNumber),
                RequestType: createHeader(41, inventoryReportProps.requestType, inventoryReportHeaders.requestType),
                Currency: createHeader(42, inventoryReportProps.currency, inventoryReportHeaders.currency),
                UserStatus: createHeader(43, inventoryReportProps.userStatus, inventoryReportHeaders.userStatus),
                BusinessCase: createHeader(44, inventoryReportProps.businessCase, inventoryReportHeaders.businessCase),
                SIMSerialNumber: createHeader(45, inventoryReportProps.simSerialNumber, inventoryReportHeaders.simSerialNumber)
            };
        }
        if (id === 2) {
            filename = `${commonFilename} Device Listing Extract – ${formattedDate}`;
            ExtractHeaders.Headers = {
                CircuitId: createHeader(1, inventoryReportProps.subscriptionNumber, inventoryReportHeaders.subscriptionNumber),
                UserFullName: createHeader(2, inventoryReportProps.userFullName, inventoryReportHeaders.userFullName),
                UserHrId: createHeader(3, inventoryReportProps.userHRID, inventoryReportHeaders.hrid),
                CostCode: createHeader(4, inventoryReportProps.costCode, inventoryReportHeaders.costCode),
                EquipmentModel: createHeader(5, inventoryReportProps.equipmentModel, inventoryReportHeaders.equipmentModel),
                Vendor: createHeader(6, inventoryReportProps.vendor, inventoryReportHeaders.vendor),
                MRC: createHeader(7, inventoryReportProps.mrc, inventoryReportHeaders.mrc),
                Currency: createHeader(8, inventoryReportProps.currency, inventoryReportHeaders.currency)
            };
        }
        // Create payload
        const data = {
            Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
            UserId: sessionStorage.getItem('UserID'),
            EmployeeId: sessionStorage.getItem('EmployeeID'),
            Headers: { ...ExtractHeaders.Headers },
            SortedColumnName: inventoryCircuitColSort,
            IsSortAscending: inventoryCircuitIsSortedAsc,
            FileName: filename,
            TableFilterList: inventoryCircuitTableFilterList,
            ApplyFilter: inventoryCircuitTableFilterApply,
            ExtractId: id
        };

        httpDownload(url, data)
            .then(function (response) {
                return response.blob();
            })
            .then(function (blob) {
                let downloadUrl = window.URL.createObjectURL(blob);
                //Hide Loading
                let a = document.createElement('a');
                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else if (typeof a.download === 'undefined') {
                    window.location = downloadUrl;
                } else {
                    a.href = downloadUrl;
                    a.download = filename + '.xlsx';
                    document.body.appendChild(a);
                    a.click();
                }
            });
    },

    addInventoryCircuitFilter: (tableFilter) => (dispatch, state) => {
        const { inventoryCircuitTableFilterList } = state().inventoryCircuit;

        var filterList = [...inventoryCircuitTableFilterList, tableFilter];

        dispatch({
            type: setInventoryCircuitFilter,
            filterList: filterList
        })
    },

    removeInventoryCircuitFilter: (removeIndex) => (dispatch, state) => {
        const { inventoryCircuitTableFilterList } = state().inventoryCircuit;

        var filterList = inventoryCircuitTableFilterList.filter((item, index) => {
            return index !== removeIndex;
        });

        dispatch({
            type: setInventoryCircuitFilter,
            filterList: filterList
        })
    },

    applyInventoryCircuitFilter: (isApply) => (dispatch, state) => {
        const { inventoryCircuitTableFilterList } = state().inventoryCircuit;

        dispatch({
            type: applyInventoryCircuitFilter,
            applyFilter: isApply,
            filterList: isApply ? inventoryCircuitTableFilterList : []
        });
    },

    saveInventoryCircuitCustomCols: (selectedCols) => async (dispatch, state) => {
        const { Headers, Pagination } = state().inventoryCircuit.inventoryCircuitItems;
        const { inventoryCircuitIsSortedAsc, inventoryCircuitColSort, inventoryCircuitTableFilterList, inventoryCircuitTableFilterApply } = state().inventoryCircuit;

        try {
            var userId = sessionStorage.getItem('UserID');

            var customizeFormData = {
                UserId: parseInt(userId),
                ReportColumnModule: REPORT_COLUMN_MODULE.CircuitInventoryManagement,
                SelectedCols: selectedCols
            };

            await httpPost('external/inventory/saveCustomizeColumns', customizeFormData);

            dispatch({
                type: setInventoryCircuitError,
                isInventoryCircuitError: false,
                isInventoryCircuitLoaded: false
            });

            var data = {
                PageFilter: {
                    PageIndex: 0,
                    PageSize: Pagination.PerPage,
                    PageSizes: Pagination.PageSizes
                },
                Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
                UserId: userId,
                EmployeeId: sessionStorage.getItem('EmployeeID'),
                Headers: {
                    ...Headers
                },
                SortedColumnName: inventoryCircuitColSort,
                IsSortAscending: inventoryCircuitIsSortedAsc,
                TableFilterList: inventoryCircuitTableFilterList,
                ApplyFilter: inventoryCircuitTableFilterApply
            };

            var inventoryItems = await httpPost('external/inventory/getAllInventoryItems', data);

            dispatch({
                type: getInventoryCircuit,
                inventoryItems: Object.keys(inventoryItems).length > 0 ? inventoryItems : DEFAULT_TABLE_RESULT_MODEL,
                isInventoryCircuitLoaded: true,
                isInventoryCircuitError: false
            });
        }
        catch (e) {
            dispatch({
                type: setInventoryCircuitError,
                isInventoryCircuitError: true,
                isInventoryCircuitLoaded: false
            });
        }
    },

    getInventoryCircuitDetail: (circuitID, circuitTypeID, billingAccountID) => async (dispatch, state) => {
        const dealName = sessionStorage.getItem('DealName');
        var res = await httpGet('external/inventory/getOrderSubsciptionDetails/' + dealName + "/" + circuitID + "/" + circuitTypeID + "/" + billingAccountID);
        var inventoryCircuitDetail = JSON.parse(JSON.stringify(initialState.inventoryCircuitDetail));

        if (res != null) {
            batch(() => {
                dispatch(actions.load("inventoryCircuitForm.circuitDetails", circuitDetailsFormInitialState));
                dispatch(actions.load("inventoryCircuitForm.location1", location1FormInitialState));
                dispatch(actions.load("inventoryCircuitForm.location2", location2FormInitialState));
                dispatch(actions.reset('inventoryCircuitForm'));

                dispatch(actions.load('inventoryCircuitForm.circuitDetails.circuitID', circuitID));
                dispatch(actions.load('inventoryCircuitForm.circuitDetails.circuitCode', res.CircuitCode));
                dispatch(actions.load('inventoryCircuitForm.circuitDetails.statusID', res.SubsStatus));
                dispatch(actions.load('inventoryCircuitForm.circuitDetails.circuitTypeID', res.CircuitTypeId));
                dispatch(actions.load('inventoryCircuitForm.circuitDetails.subCircuitTypeID', res.SubCircuitTypeId));
                dispatch(actions.load('inventoryCircuitForm.circuitDetails.monthlyRateCharge', res.MRC === 0 ? "0.00" : res.MRC));
                dispatch(actions.load('inventoryCircuitForm.circuitDetails.primarySecondary', res.PrimarySecondary));
                dispatch(actions.load('inventoryCircuitForm.circuitDetails.linkedCircuitID', res.LinkedCircuitID));
                dispatch(actions.load('inventoryCircuitForm.circuitDetails.billingAccountID', res.FinanceAccountID));
                dispatch(actions.load('inventoryCircuitForm.circuitDetails.endUserID', res.EndUserID));
                dispatch(actions.load('inventoryCircuitForm.circuitDetails.installDate', res.InstallDate != null ? new Date(res.InstallDate) : ''));
                dispatch(actions.load('inventoryCircuitForm.circuitDetails.disconnectDate', res.DisconDate != null ? new Date(res.DisconDate) : ''));
                dispatch(actions.load('inventoryCircuitForm.circuitDetails.suspensionFromDate', res.SuspensionFromDate != null ? new Date(res.SuspensionFromDate) : ''));
                dispatch(actions.load('inventoryCircuitForm.circuitDetails.suspensionToDate', res.SuspensionToDate != null ? new Date(res.SuspensionToDate) : ''));
                dispatch(actions.load('inventoryCircuitForm.circuitDetails.contractEndDate', res.ContractEndDate != null ? new Date(res.ContractEndDate) : ''));
                dispatch(actions.load('inventoryCircuitForm.circuitDetails.financeAccountTypeName', res.FinanceAccountTypeName));
                dispatch(actions.load('inventoryCircuitForm.circuitDetails.currency', res.CurrencyName));
                dispatch(actions.load('inventoryCircuitForm.circuitDetails.clientName', res.ClientName));
                dispatch(actions.load('inventoryCircuitForm.circuitDetails.vendor', res.Vendor));
                dispatch(actions.load('inventoryCircuitForm.circuitDetails.userName', res.LastnameFirstname));
                dispatch(actions.load('inventoryCircuitForm.circuitDetails.emailAddress', res.EmailAdd));
                dispatch(actions.load('inventoryCircuitForm.circuitDetails.lineManager', res.LineManager));
                dispatch(actions.load('inventoryCircuitForm.circuitDetails.vendorID', res.VendorID));

                dispatch(actions.load('inventoryCircuitForm.location1.locationID', res.Location1ID));
                dispatch(actions.load('inventoryCircuitForm.location2.locationID', res.Location2ID));

                if (res.LocationAddress !== null && res.LocationAddress?.State === true) {
                    dispatch(actions.load('inventoryCircuitForm.location1.locationID', res.LocationAddress.LocationId));
                    dispatch(actions.load('inventoryCircuitForm.location1.address1', res.LocationAddress.LocationAddress1));
                    dispatch(actions.load('inventoryCircuitForm.location1.address2', res.LocationAddress.LocationAddress2));
                    dispatch(actions.load('inventoryCircuitForm.location1.locationType', res.LocationAddress.LocationType));
                    dispatch(actions.load('inventoryCircuitForm.location1.locationCity', res.LocationAddress.LocationCity));
                    dispatch(actions.load('inventoryCircuitForm.location1.locationState', res.LocationAddress.LocationState));
                    dispatch(actions.load('inventoryCircuitForm.location1.locationCountry', res.LocationAddress.CountryName));
                    dispatch(actions.load('inventoryCircuitForm.location1.locationZip', res.LocationAddress.LocationZip));
                }
                dispatch(actions.load('inventoryCircuitForm.location1.demarcLocation', res.DemarcLocation ?? ''));

                if (res.LocationP2P !== null && res.LocationP2P?.State === true) {
                    dispatch(actions.load('inventoryCircuitForm.location2.locationID', res.LocationP2P.LocationId));
                    dispatch(actions.load('inventoryCircuitForm.location2.address1', res.LocationP2P.LocationAddress1));
                    dispatch(actions.load('inventoryCircuitForm.location2.address2', res.LocationP2P.LocationAddress2));
                    dispatch(actions.load('inventoryCircuitForm.location2.locationType', res.LocationP2P.LocationType));
                    dispatch(actions.load('inventoryCircuitForm.location2.locationCity', res.LocationP2P.LocationCity));
                    dispatch(actions.load('inventoryCircuitForm.location2.locationState', res.LocationP2P.LocationState));
                    dispatch(actions.load('inventoryCircuitForm.location2.locationCountry', res.LocationP2P.CountryName));
                    dispatch(actions.load('inventoryCircuitForm.location2.locationZip', res.LocationP2P.LocationZip));
                }
                dispatch(actions.load('inventoryCircuitForm.location2.demarcLocation', res.DemarcLocationPTP ?? ''));

                dispatch({
                    type: getInventoryCircuitDetail,
                    inventoryCircuitDetail: inventoryCircuitDetail,
                    isInventoryCircuitLoaded: true,
                    isInventoryCircuitError: false
                });
            });
        } else {
            batch(() => {
                dispatch(actions.load("inventoryCircuitForm.circuitDetails", circuitDetailsFormInitialState));
                dispatch(actions.load("inventoryCircuitForm.location1", location1FormInitialState));
                dispatch(actions.load("inventoryCircuitForm.location2", location2FormInitialState));
                dispatch(actions.reset('inventoryCircuitForm'));

                dispatch({
                    type: setInventoryCircuitError,
                    isInventoryCircuitError: true,
                    isInventoryCircuitLoaded: false
                });
            });
        }
    },

    getUserHrDetails:(employeeId) => async (dispatch, state) => {
        const dealName = sessionStorage.getItem('DealName');
        const { activeDateFormat } = state().adminSetting;
        var userDetail = await httpGet('external/inventory/getUserHrDetails/' + dealName + "/" + employeeId);
        var inventoryUserHrDetails = JSON.parse(JSON.stringify(initialState.inventoryUserHrDetails));
        if(userDetail != null){

            inventoryUserHrDetails.employeeId = userDetail.EmployeeId;
            inventoryUserHrDetails.hrSapId = userDetail.HrSapId;
            inventoryUserHrDetails.firstName = userDetail.FirstName;
            inventoryUserHrDetails.lastName = userDetail.LastName;
            inventoryUserHrDetails.middle = userDetail.MiddleInitial;
            inventoryUserHrDetails.emailAdd = userDetail.EmailAddress;
            inventoryUserHrDetails.position = userDetail.Position;
            inventoryUserHrDetails.status = userDetail.Status;
            inventoryUserHrDetails.dateleft = userDetail.DateLeft ? convertToFormatLocalDate(new Date(userDetail.DateLeft), activeDateFormat.Name) : null;
            inventoryUserHrDetails.firstLineManagerId = userDetail.FirstLineManagerID;
            inventoryUserHrDetails.firstLineManagerEmailAdd = userDetail.FirstLineManagerEmailAddress;
            inventoryUserHrDetails.secondLineManagerId = userDetail.SecondLineManagerID;
            inventoryUserHrDetails.secondLineManageremailAdd = userDetail.SecondLineManagerEmailAddress;
            inventoryUserHrDetails.delegateAprover = userDetail.DelegateApprover;
            inventoryUserHrDetails.locationSiteId = userDetail.LocationSiteId;
            inventoryUserHrDetails.address1 = userDetail.Address1;
            inventoryUserHrDetails.address2 = userDetail.Address2;
            inventoryUserHrDetails.city = userDetail.City;
            inventoryUserHrDetails.locationState = userDetail.LocationState;
            inventoryUserHrDetails.country = userDetail.Country;
            inventoryUserHrDetails.locationZip = userDetail.Zip;

            dispatch(actions.reset('inventoryUserDetails'));
            dispatch(actions.change('inventoryUserDetails.employeeId', inventoryUserHrDetails.employeeId));
            dispatch(actions.change('inventoryUserDetails.hrSapId', inventoryUserHrDetails.hrSapId));
            dispatch(actions.change('inventoryUserDetails.firstName', inventoryUserHrDetails.firstName));
            dispatch(actions.change('inventoryUserDetails.lastName', inventoryUserHrDetails.lastName));
            dispatch(actions.change('inventoryUserDetails.middle', inventoryUserHrDetails.middle));
            dispatch(actions.change('inventoryUserDetails.emailAdd', inventoryUserHrDetails.emailAdd));
            dispatch(actions.change('inventoryUserDetails.position', inventoryUserHrDetails.position));
            dispatch(actions.change('inventoryUserDetails.status', inventoryUserHrDetails.status));
            dispatch(actions.change('inventoryUserDetails.dateleft', inventoryUserHrDetails.dateleft));
            dispatch(actions.change('inventoryUserDetails.firstLineManagerId', inventoryUserHrDetails.firstLineManagerId));
            dispatch(actions.change('inventoryUserDetails.firstLineManagerEmailAdd', inventoryUserHrDetails.firstLineManagerEmailAdd));
            dispatch(actions.change('inventoryUserDetails.secondLineManagerId', inventoryUserHrDetails.secondLineManagerId));
            dispatch(actions.change('inventoryUserDetails.secondLineManageremailAdd', inventoryUserHrDetails.secondLineManageremailAdd));
            dispatch(actions.change('inventoryUserDetails.delegateAprover', inventoryUserHrDetails.delegateAprover));
            dispatch(actions.change('inventoryUserDetails.locationSiteId', inventoryUserHrDetails.locationSiteId));
            dispatch(actions.change('inventoryUserDetails.address1', inventoryUserHrDetails.address1));
            dispatch(actions.change('inventoryUserDetails.address1', inventoryUserHrDetails.address2));
            dispatch(actions.change('inventoryUserDetails.city', inventoryUserHrDetails.city));
            dispatch(actions.change('inventoryUserDetails.locationState', inventoryUserHrDetails.locationState));
            dispatch(actions.change('inventoryUserDetails.country', inventoryUserHrDetails.country));
            dispatch(actions.change('inventoryUserDetails.locationZip', inventoryUserHrDetails.locationZip));

            dispatch({
                type: getInventoryUserDetail,
                inventoryUserHrDetails: inventoryUserHrDetails,
                isInventoryUserDetailLoaded: true,
                isInventoryUserDetailError: false
            });
        }
    },

    getUserCircuitAllocation: (employeeId) => async (dispatch, state) => {
        const dealName = sessionStorage.getItem('DealName');
        var res = await httpGet('external/inventory/getUserCircuitAllocation/' + dealName + "/" + employeeId);

        if (res != null)
        {
            dispatch({
                type: getInventoryUserCircuitAllocation,
                inventoryUserCircuitAllocation: Object.keys(res).length > 0 ? res : DEFAULT_TABLE_RESULT_MODEL,
            });
        }
    },
    getUserLinkedCircuit: (employeeId, searchVal, pageIndex = 0) => async (dispatch, state) => {
        const { Pagination } = state().inventoryCircuit.inventoryLinkedCircuit;
        const dealName = sessionStorage.getItem('DealName');
        var data = {
            SearchValue: searchVal,
            PageFilter:{
                PageIndex: pageIndex !== undefined ? pageIndex : 0,
                PageSize: Pagination.PerPage,
                PageSizes: Pagination.PageSizes
            }
        }

        var res = await httpPost('external/inventory/getUserLinkedCircuit/' + dealName + "/" + employeeId, data);

        dispatch({
            type: getUserLinkedCircuit,
            inventoryUserLinkedCircuit: Object.keys(res).length > 0 ? res : DEFAULT_TABLE_RESULT_MODEL,
        });
    },
    selectBillingAccountID: (value) => async (dispatch, state) => {
        const dealName = sessionStorage.getItem('DealName');
        var accountDetail = await httpGet('external/inventoryManager/getAccountDetailsModal/' + dealName + "/" + value);

        dispatch(actions.change('inventoryCircuitForm.circuitDetails.billingAccountID', value));
        dispatch(actions.change('inventoryCircuitForm.circuitDetails.financeAccountTypeName', accountDetail.AccountType));
        dispatch(actions.change('inventoryCircuitForm.circuitDetails.currency', accountDetail.Currency));
        dispatch(actions.change('inventoryCircuitForm.circuitDetails.clientName', accountDetail.Client));
        dispatch(actions.change('inventoryCircuitForm.circuitDetails.vendor', accountDetail.Vendor));
        dispatch(actions.change('inventoryCircuitForm.circuitDetails.vendorID', accountDetail.VendorID));
        dispatch(actions.reset('inventoryCircuitForm.circuitDetails.linkedCircuitID'));
    },
    resetBillingAccount: () => async (dispatch, state) => {
        dispatch(actions.reset('inventoryCircuitForm.circuitDetails.billingAccountID'));
        dispatch(actions.reset('inventoryCircuitForm.circuitDetails.financeAccountTypeName'));
        dispatch(actions.reset('inventoryCircuitForm.circuitDetails.currency'));
        dispatch(actions.reset('inventoryCircuitForm.circuitDetails.clientName'));
        dispatch(actions.reset('inventoryCircuitForm.circuitDetails.vendor'));
        dispatch(actions.reset('inventoryCircuitForm.circuitDetails.vendorID'));
        dispatch(actions.reset('inventoryCircuitForm.circuitDetails.linkedCircuitID'));
    },
    selectCircuitTypeID: () => async (dispatch) => {
        dispatch(actions.reset('inventoryCircuitForm.circuitDetails.linkedCircuitID'));
    },
    selectCircuitRank: (model, value) => async (dispatch) => {
        dispatch(actions.change(model, value));
        dispatch(actions.reset('inventoryCircuitForm.circuitDetails.linkedCircuitID'));
    },
    GetlinkCircuitsByBillingAccountIdAndCircuitTypeId: (circuitId, circuitTypeId, billingAccountId) => async (dispatch, state) => {
        const dealName = sessionStorage.getItem('DealName');
        dispatch({
            type: GetlinkCircuitsByBillingAccountIdAndCircuitTypeId,
            linkedCircuitsOptions: []
        });        
        var linkCirccuits = await httpGet('external/inventoryManager/GetlinkCircuitsByBillingAccountIdAndCircuitTypeId/' + dealName + "/" + circuitId + '/' + circuitTypeId + '/' + billingAccountId);
        if (linkCirccuits.length > 0) {
            dispatch({
                type: GetlinkCircuitsByBillingAccountIdAndCircuitTypeId,
                linkedCircuitsOptions: linkCirccuits
            });
        }       
    },
    getAccountDetailsModal: (billingAccountID) => async (dispatch, state) => {
        const dealName = sessionStorage.getItem('DealName');
        var accountDetail = await httpGet('external/inventoryManager/getAccountDetailsModal/' + dealName + "/" + billingAccountID);
        var inventoryAccountDetails = JSON.parse(JSON.stringify(initialState.inventoryAccountDetails));
        if(accountDetail != null){
            inventoryAccountDetails.accountID = accountDetail.AccountID;
            inventoryAccountDetails.accountNumber = accountDetail.AccountNumber;
            inventoryAccountDetails.accountType = accountDetail.AccountType;
            inventoryAccountDetails.contractID = accountDetail.ContractName;
            inventoryAccountDetails.vendor = accountDetail.Vendor;
            inventoryAccountDetails.currency = accountDetail.Currency;
            inventoryAccountDetails.serviceType = accountDetail.ServiceType;
            inventoryAccountDetails.status = accountDetail.Status;
            inventoryAccountDetails.client = accountDetail.Client;
            inventoryAccountDetails.allocationLevel = accountDetail.AllocationLevel;
            inventoryAccountDetails.apVendorID = accountDetail.APVendorID;
            inventoryAccountDetails.remitID = accountDetail.RemitID;
            inventoryAccountDetails.billingSite = accountDetail.BillingSite;
            inventoryAccountDetails.billingAdd1 = accountDetail.BillingAdd1;
            inventoryAccountDetails.billingAdd2 = accountDetail.BillingAdd2;
            inventoryAccountDetails.billingLocationType = accountDetail.BillingLocationType;
            inventoryAccountDetails.billingCity = accountDetail.BillingCity;
            inventoryAccountDetails.billingState = accountDetail.BillingState;
            inventoryAccountDetails.billingLocation = accountDetail.BillingLocation;
            inventoryAccountDetails.billingZip = accountDetail.BillingZip;
            inventoryAccountDetails.remitSite = accountDetail.RemitSite;
            inventoryAccountDetails.remitAdd1 = accountDetail.RemitAdd1;
            inventoryAccountDetails.remitAdd2 = accountDetail.RemitAdd2;
            inventoryAccountDetails.remitLocationType = accountDetail.RemitLocationType;
            inventoryAccountDetails.remitCity = accountDetail.RemitCity;
            inventoryAccountDetails.remitState = accountDetail.RemitState;
            inventoryAccountDetails.remitLocation = accountDetail.RemitLocation;
            inventoryAccountDetails.remitZip = accountDetail.RemitZip;
            inventoryAccountDetails.billingAddress = accountDetail.BillingAddress;
            inventoryAccountDetails.remitAddress = accountDetail.RemitAddress;

            dispatch({
                type: getInventoryAccountDetail,
                inventoryAccountDetails: inventoryAccountDetails,
                isInventoryAccountDetailLoaded: true,
                isInventoryAccountDetailError: false
            });
        }
    },
    getAccountCostAllocationModal: (billingAccountID) => async (dispatch, state) => {
        const dealName = sessionStorage.getItem('DealName');
        var res = await httpGet('external/inventoryManager/getAccountCostAllocationModal/' + dealName + "/" + billingAccountID);

        if (res != null)
        {
            dispatch({
                type: getInventoryAccountCostAllocationModal,
                inventoryAccountCostAllocationModal: Object.keys(res).length > 0 ? res : DEFAULT_TABLE_RESULT_MODEL,
            });
        }
    },
    getAccountLinkedCircuit: (billingAccountID, searchVal, pageIndex = 0) => async (dispatch, state) => {
        const { Pagination } = state().inventoryCircuit.inventoryAccountLinkedCircuitTable;
        const dealName = sessionStorage.getItem('DealName');
        var data = {
            SearchValue: searchVal,
            PageFilter:{
                PageIndex: pageIndex !== undefined ? pageIndex : 0,
                PageSize: Pagination.PerPage,
                PageSizes: Pagination.PageSizes
            }
        }

        var res = await httpPost('external/inventoryManager/getAccountLinkedCircuit/' + dealName + "/" + billingAccountID, data);

        dispatch({
            type: getAccountLinkedCircuit,
            inventoryAccountLinkedCircuit: Object.keys(res).length > 0 ? res : DEFAULT_TABLE_RESULT_MODEL,
        });
    },

    getInventoryAllDropdownList: () => async (dispatch, state) => {
        const res = await httpGet('external/inventory/getAllInventoryDropDown');

        if (res != null) {
            dispatch({
                type: getInventoryAllDropdownList,
                inventoryAllAccountDetails: res.BillingAccounts,
                inventoryAllAccountTypes: res.BillingAccountTypes,
                inventoryAllAccountStatuses: res.CircuitStatuses,
                inventoryAllCircuitRankings: res.CircuitRankings,
                circuitGlCodeList: res.CircuitGLCodes,
                inventoryAllEmployees: res.Employees,
                inventoryAllCircuitEquipment: res.EquipmentTypes,
                inventoryAllLocations: res.Locations,
                inventoryAllCircuitSimTypes: res.SimTypes,
                isInventoryCircuitLoaded: true,
                isInventoryCircuitError: false
            });
        } else {
            dispatch({
                type: setInventoryCircuitError,
                isInventoryCircuitError: true,
                isInventoryCircuitLoaded: false
            });
        }
    },

    getEquipmentDetailsList: (circuitID) => async (dispatch, state) => {
        const { Headers } = state().inventoryCircuit.inventoryEquipmentItems;
        const { Items } = state().inventoryCircuit.inventoryEquipmentItems.Data;
        var data = {
            Headers: {
                ...Headers
            },
            Data: {
                ...Items
            },
        };
        var inventoryItems = await httpGet('external/inventory/getCircuitInventoryEquipmentList?circuitId=' + circuitID, data);
        if (inventoryItems.ok === false) {
            dispatch({
                type: getEquipmentDetailsList,
                inventoryItems: Object.keys(inventoryItems).length > 0 ? inventoryItems : DEFAULT_TABLE_RESULT_MODEL,
                isInventoryCircuitLoaded: true,
                isInventoryCircuitError: false
            });
        } else {
            dispatch({
                type: getEquipmentDetailsList,
                inventoryItems: Object.keys(inventoryItems).length > 0 ? inventoryItems : DEFAULT_TABLE_RESULT_MODEL,
                isInventoryCircuitLoaded: true,
                isInventoryCircuitError: false
            });
        }

    },

    postInventoryCircuitComments: (circuitID, filename, fileData, comment) => async (dispatch, state) => {

        var formData = new FormData();

        if (fileData.length > 0) {
            fileData.forEach((element) => formData.append("FileData", element));
            formData.append("FileName", JSON.stringify(filename));
        }

        formData.append("Comment", comment.toString());
        formData.append("UserId", parseInt(sessionStorage.getItem('UserID')),);
        formData.append("CircuitID", circuitID);

        var res = await httpPostFile('external/inventoryManager/setCircuitComments', formData);

        if (res != null) {
            dispatch({
                type: getInventoryCircuitComments,
                inventoryCircuitComments: res,
                isInventoryCircuitLoaded: true,
                isInventoryCircuitError: false
            });
        } else {
            dispatch({
                type: setInventoryCircuitError,
                isInventoryCircuitError: true,
                isInventoryCircuitLoaded: false
            });
        }
    },

    getInventoryCircuitComments: (circuitID) => async (dispatch, state) => {
        var res = await httpGet('external/inventoryManager/getInvCircuitComments?circuitID=' + circuitID + '&timeZone=' + getLocalTimeZone() + '&eID=' +  sessionStorage.getItem('EID'));

        if (res != null) {
            dispatch({
                type: getInventoryCircuitComments,
                inventoryCircuitComments: res,
                isInventoryCircuitLoaded: true,
                isInventoryCircuitError: false
            });
        } else {
            dispatch({
                type: setInventoryCircuitError,
                isInventoryCircuitError: true,
                isInventoryCircuitLoaded: false
            });
        }
    },

    deleteInventoryCircuitComments: (commentId) => async (dispatch, state) => {
        var userId = sessionStorage.getItem("UserID")
        var res = await httpPost('external/inventoryManager/circuitInvDeleteComment/' + commentId + '/' + userId);

        if (res != null) {
            dispatch({
                type: getInventoryCircuitComments,
                circuitDeleteComment: res,
                isInventoryCircuitLoaded: true,
                isInventoryCircuitError: false
            });
        } else {
            dispatch({
                type: setInventoryCircuitError,
                isInventoryCircuitError: true,
                isInventoryCircuitLoaded: false
            });

        }
    },

    getInventoryCircuitTypesByCategory: (categoryid) => async (dispatch, state) => {
        var res = await httpGet('external/inventory/getInventoryCircuitTypesByCategory/' + categoryid);

        if (res != null) {
            dispatch({
                type: getInventoryCircuitTypesByCategory,
                inventoryCircuitTypesByCategory: res,
                isInventoryCircuitLoaded: true,
                isInventoryCircuitError: false
            });
        } else {
            dispatch({
                type: setInventoryCircuitError,
                isInventoryCircuitError: true,
                isInventoryCircuitLoaded: false
            });
        }
    },

    getInventoryAllSubCircuitTypes: (id) => async (dispatch, state) => {
        var res = await httpGet('external/inventory/getInventoryAllSubCircuitTypes/' + id);

        if (res != null) {
            dispatch({
                type: getInventoryAllSubCircuitTypes,
                inventorySubCircuitTypes: res,
                isInventoryCircuitLoaded: true,
                isInventoryCircuitError: false
            });
        } else {
            dispatch({
                type: setInventoryCircuitError,
                isInventoryCircuitError: true,
                isInventoryCircuitLoaded: false
            });
        }
    },

    selectUserHRID: (value, endUserID) => (dispatch, state) => {
        const { inventoryAllEmployees } = state().inventoryCircuit;

        if (value) {
            var res = inventoryAllEmployees.find(r => r.EmployeeID === value);

            dispatch(actions.change(endUserID.model, value));
            dispatch(actions.change('inventoryCircuitForm.circuitDetails.userName', "" + res.LastnameFirstname));
            dispatch(actions.change('inventoryCircuitForm.circuitDetails.emailAddress', "" + res.Email));
            dispatch(actions.change('inventoryCircuitForm.circuitDetails.lineManager', res.FirstLineManagerEmail != null ? "" + res.FirstLineManagerEmail : ""));
        }
    },

    resetInventoryCircuitForm: () => (dispatch) => {
        batch(() => {
            dispatch(actions.load("inventoryCircuitForm.circuitDetails", circuitDetailsFormInitialState));
            dispatch(actions.load("inventoryCircuitForm.location1", location1FormInitialState));
            dispatch(actions.load("inventoryCircuitForm.location2", location2FormInitialState));
            dispatch(actions.reset('inventoryCircuitForm'));
            dispatch({ type: setInventoryCircuitFormSubmitted, data: false });
        });
    },

    updateChangeLocationSite: (model, value) => async (dispatch, state) => {
        dispatch(actions.change(model, value));
        dispatch({
            type: updateChangeLocationSite,
            circuitLocationAddress: model,
            isInventoryCircuitLoaded: true,
            isInventoryCircuitError: false
        });
    },

    updateChangeLocationSiteP2P: (model, value) => async (dispatch, state) => {
        dispatch(actions.change(model, value));
        dispatch({
            type: updateChangeLocationSiteP2P,
            circuitLocationP2P: model,
            isInventoryCircuitLoaded: true,
            isInventoryCircuitError: false
        });
    },

    setUserLinkedCircuitSearchValue: (val, isFilter = false, filterBy = null) => (dispatch) => {
        dispatch({
            type: setUserLinkedCircuitSearchValue
            , value: val
            , filterBy: filterBy
            , isFilter: isFilter
        });
    },

    setAccountLinkedCircuitSearchValue: (val, isFilter = false, filterBy = null) => (dispatch) => {
        dispatch({
            type: setAccountLinkedCircuitSearchValue
            , value: val
            , filterBy: filterBy
            , isFilter: isFilter
        });
    },

    resetInventoryCircuitData: () => async (dispatch) => {
        dispatch({ type: resetInventoryCircuitData, data: DEFAULT_TABLE_RESULT_MODEL });
    },
};

async function getInventoryCircuitTable(inventoryCircuit, pageIndex = 0, pageUnmount) {
    const { Headers, Pagination } = inventoryCircuit.inventoryCircuitItems;
    const { inventoryCircuitIsSortedAsc, inventoryCircuitColSort, inventoryCircuitTableFilterList, inventoryCircuitTableFilterApply } = inventoryCircuit;
    var userId = sessionStorage.getItem('UserID');

    const headersToSend = pageUnmount ? {} : { ...Headers };

    var data = {
        PageFilter: {
            PageIndex: pageIndex !== undefined ? pageIndex : 0,
            PageSize: Pagination.PerPage,
            PageSizes: Pagination.PageSizes
        },
        Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
        UserId: userId,
        EmployeeId: sessionStorage.getItem('EmployeeID'),
        Headers: headersToSend,
        SortedColumnName: inventoryCircuitColSort,
        IsSortAscending: inventoryCircuitIsSortedAsc,
        TableFilterList: inventoryCircuitTableFilterList,
        ApplyFilter: inventoryCircuitTableFilterApply
    };

    console.log("test", inventoryCircuit.inventoryCircuitItems, data)

    var inventoryItems = await httpPost('external/inventory/getAllInventoryItems', data);

    return inventoryItems;
}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case getInventoryCircuitCostCenterList:
            return {
                ...state,
                circuitCostCenterList: action.circuitCostCenterList
             };
        case getInventoryCircuit:
            return {
                ...state,
                inventoryCircuitItems: action.inventoryItems,
                isInventoryCircuitLoaded: action.isInventoryCircuitLoaded,
                isInventoryCircuitError: action.isInventoryCircuitError
            };
        case setInventoryCircuitError:
            return {
                ...state,
                isInventoryCircuitError: action.isInventoryCircuitError,
                isInventoryCircuitLoaded: action.isInventoryCircuitLoaded
            }
        case setInventoryCircuitColSearchStr:
            return {
                ...state,
                inventoryCircuitItems: action.data,
                isInventoryCircuitLoaded: action.isInventoryCircuitLoaded,
                isInventoryCircuitError: action.isInventoryCircuitError
            }
        case sortInventoryCircuitItems:
            return {
                ...state,
                inventoryCircuitItems: action.inventoryCircuitItems,
                inventoryCircuitColSort: action.inventoryCircuitColSort,
                inventoryCircuitIsSortedAsc: action.inventoryCircuitIsSortedAsc,
                isInventoryCircuitLoaded: action.isInventoryCircuitLoaded
            }
        case setInventoryCircuitPageSize:
            return {
                ...state,
                inventoryCircuitItems: {
                    ...state.inventoryCircuitItems,
                    Pagination: {
                        ...state.inventoryCircuitItems.Pagination,
                        PerPage: action.pageSize
                    }
                }
            }
        case setInventoryCircuitFilter:
            return {
                ...state,
                inventoryCircuitTableFilterList: action.filterList
            }
        case applyInventoryCircuitFilter:
            return {
                ...state,
                inventoryCircuitTableFilterApply: action.applyFilter,
                inventoryCircuitTableFilterList: action.filterList
            }
        case getInventoryCircuitDetail:
            return {
                ...state,
                inventoryCircuitDetail: action.inventoryCircuitDetail
            }
        case getEquipmentDetailsList:
            return {
                ...state,
                inventoryEquipmentItems: action.inventoryItems,
                isInventoryCircuitLoaded: action.isInventoryCircuitLoaded,
                isInventoryCircuitError: action.isInventoryCircuitError
            }
        case getInventoryUserDetail:
            return{
                ...state,
                inventoryUserHrDetails: action.inventoryUserHrDetails
            }
        case getInventoryUserCircuitAllocation:
            return{
                ...state,
                inventoryUserCircuitAllocation: action.inventoryUserCircuitAllocation
            }
        case getUserLinkedCircuit:
            return{
                ...state,
                inventoryUserLinkedCircuit: action.inventoryUserLinkedCircuit
            }
        case getInventoryAccountDetail:
                return{
                    ...state,
                    inventoryAccountDetails: action.inventoryAccountDetails
                };
        case getInventoryAccountCostAllocationModal:
                return{
                    ...state,
                    inventoryAccountCostAllocationModal: action.inventoryAccountCostAllocationModal
                };
        case getAccountLinkedCircuit:
                return{
                    ...state,
                    inventoryAccountLinkedCircuit: action.inventoryAccountLinkedCircuit
                }
        case getInventoryCircuitComments:
            return {
                ...state,
                inventoryCircuitComments: action.inventoryCircuitComments
            };
        case setInventoryCircuitFormSubmitted:
            return {
                ...state,
                formSubmitted: action.data
            };
        case getInventoryCircuitTypesByCategory:
            return {
                ...state,
                inventoryCircuitTypesByCategory: action.inventoryCircuitTypesByCategory
            }            
        case getInventoryAllSubCircuitTypes:
            return {
                ...state,
                inventorySubCircuitTypes: action.inventorySubCircuitTypes
            }
        case updateChangeLocationSite:
            return {
                ...state,
                circuitLocationAddress: action.circuitLocationAddress
            }
        case updateChangeLocationSiteP2P:
            return {
                ...state,
                circuitLocationP2P: action.circuitLocationP2P
            }
        case setUserLinkedCircuitSearchValue:
            return {
                ...state
                , searchValue: action.value
                , isFilter: action.isFilter
                , filterBy: action.filterBy
            };
        case setAccountLinkedCircuitSearchValue:
                return {
                    ...state
                    , searchValue: action.value
                    , isFilter: action.isFilter
                    , filterBy: action.filterBy
            };
        case GetlinkCircuitsByBillingAccountIdAndCircuitTypeId:
            return {
                ...state,
                linkedCircuitsOptions: action.linkedCircuitsOptions
            };
        case getInventoryAllDropdownList:
            return {
                ...state,
                inventoryAllAccountDetails: action.inventoryAllAccountDetails,
                inventoryAllAccountTypes: action.inventoryAllAccountTypes,
                inventoryAllAccountStatuses: action.inventoryAllAccountStatuses,
                inventoryAllCircuitRankings: action.inventoryAllCircuitRankings,
                circuitGlCodeList: action.circuitGlCodeList,
                inventoryAllCircuitEquipment: action.inventoryAllCircuitEquipment,
                inventoryAllEmployees: action.inventoryAllEmployees,
                inventoryAllLocations: action.inventoryAllLocations,
                inventoryAllCircuitSimTypes: action.inventoryAllCircuitSimTypes,
            };
        case resetInventoryCircuitData:
            return {
                ...state,
                inventoryCircuitItems: action.data
            };
        default:
            return state;
    }
};